const article = {
  slug: 'transfers',
  title: 'Unit transfers',
  section: 'Daily tasks',
  body: `
# Transfer a tenant to another unit

Use the **Transfer** action on the rental row.

1. Pick the destination unit (must be Available).
2. The rental moves: old unit -> Available, new unit -> Occupied.
3. Rate follows the new unit; the transfer is recorded on the rental's
   history so billing continuity is auditable.
4. If the new unit has a different gate code setup, the gate-code logic
   re-resolves.

> Don't edit the rental's unit field by hand - the Transfer action is
> what keeps unit statuses, history, and billing consistent.
`,
};

export default article;
